import React, {forwardRef, Ref, useImperativeHandle, useState} from "react"
import SnackBar from "./SnackBar";

interface Props {
    duration?: number
}

export interface AlertRefProps {
    info: (text: string) => void,
    error: (text: string) => void,
}

export default forwardRef<AlertRefProps, Props>((props: Props, ref: Ref<AlertRefProps>) => {

    // Props

    const {duration = 2500} = props;

    // State

    const [show, setShow] = useState(false);
    const [text, setText] = useState('');
    const [isError, setIsError] = useState(false);

    // Imperative

    useImperativeHandle(ref, () => ({
        info: (text) => {
            setText(text);
            setShow(true);
            setTimeout(setShow.bind(null, false), duration);
        },
        error: (text) => {
            setText(text);
            setIsError(true);
            setShow(true);
            setTimeout(() => {
                setIsError(false);
                setShow(false)
            }, duration);
        }
    }));

    return <SnackBar isError={isError} show={show} text={text}/>
});
